export const SET_ACCOUNTING_TYPES = "SET_ACCOUNTING_TYPES";
export const SET_ACCOUNTING = "SET_ACCOUNTING";
export const SET_ACCOUNTINGS = "SET_ACCOUNTINGS";
